import React, { useState } from 'react';
import * as S from './styles';
export interface DropdownProps {
  label: string;
  value?: string;
  placeholder: string;
  options: string[];
  error?: string;
  onSelect: (value: string) => void;
}

export const Dropdown: React.FC<DropdownProps> = ({ label, value, placeholder, options, error, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);

  const selectText = isOpen ? placeholder : !!value && value.length > 0 ? value : placeholder;

  return (
    <S.Container>
      {label && value && <S.Label>{label}</S.Label>}
      <S.SelectWrapper focus={isOpen} onClick={() => setIsOpen(!isOpen)}>
        <S.SelectText>
          {isOpen || !value ? <span className="placeholder-text">{placeholder}</span> : <span>{selectText}</span>}
        </S.SelectText>
        {isOpen ? (
          <img
            className="image"
            src="https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/arrow-up.svg"
            alt="arrow-up"
          />
        ) : (
          <img
            className="image"
            src="https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/arrow-down.svg"
            alt="arrow-down"
          />
        )}
      </S.SelectWrapper>
      {error && (
        <div className="error-wrapper">
          <small className="error-message">{error}</small>
        </div>
      )}
      {isOpen && (
        <S.OptionsWrapper>
          {options.map(option => (
            <S.Option
              key={option}
              onClick={() => {
                setIsOpen(false);
                onSelect(option);
              }}
            >
              <div className="option-text">{option}</div>
            </S.Option>
          ))}
        </S.OptionsWrapper>
      )}
    </S.Container>
  );
};
